import { render, staticRenderFns } from "./kyc-account-tab.vue?vue&type=template&id=210744b0"
import script from "./kyc-account-tab.vue?vue&type=script&lang=js"
export * from "./kyc-account-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports